import React, { FC } from 'react';
import { TaskIdV2 } from 'api/models';
import { Maybe } from 'core/maybe';
import { AddTimeEntryDrawerControlled } from './add-time-entry-drawer-controlled';
import { useTimeEntryDrawerProps } from './use-time-entry-drawer-props';

interface Props {
  taskId: TaskIdV2;
  onClose: () => void;
  defaultBillable?: boolean;
  defaultCategory?: Maybe<number>;
  billableDisabled?: boolean;
  projectId: number;
}

export const AddTimeEntryDrawer: FC<Props> = (props) => {
  const drawerProps = useTimeEntryDrawerProps(props);

  return <AddTimeEntryDrawerControlled {...drawerProps} />;
};
